import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ReactNode } from 'react'

interface QueryProviderProps {
  children: ReactNode
}

// QueryClient 인스턴스 생성
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 다른 탭·다른 관리자가 바꾼 값이 같은 조건 재조회·탭 복귀 때 바로 보이도록
      // 기본은 항상 다시 받는다 (RDL-176). 거의 안 바뀌는 선택지 쿼리만 개별로 staleTime을 준다.
      staleTime: 0,
      gcTime: 10 * 60 * 1000, // 10분 (이전 cacheTime)
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 1,
    },
  },
})

export const QueryProvider = ({ children }: QueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
